import { render, staticRenderFns } from "./RejectReasonsView.vue?vue&type=template&id=61d47933&scoped=true"
import script from "./RejectReasonsView.vue?vue&type=script&lang=js"
export * from "./RejectReasonsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d47933",
  null
  
)

export default component.exports